import React from "react";

import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, InputNumber } from "antd";

import "./InventoryCardStepper.css";

const formatQuantity = (val) => (val == null || val === "" ? "00" : String(val).padStart(2, "0"));

const parseQuantity = (val) => {
  const digits = String(val ?? "").replace(/\D/g, "");
  return digits ? Number(digits) : 0;
};

const clampMin = (value, min) => Math.max(min, parseQuantity(value));

const blockNonNumericInput = (e) => {
  if (e.ctrlKey || e.metaKey || e.key.length !== 1 || /\d/.test(e.key)) return;
  e.preventDefault();
};

const InventoryCardStepper = ({
  value,
  min = 0,
  onChange,
  className = "",
}) => {
  const setValue = (next) => onChange(clampMin(next, min));

  return (
    <div className={["InventoryCardStepper", className].filter(Boolean).join(" ")}>
      <Button
        type="default"
        className="InventoryCardStepper__Button"
        disabled={value <= min}
        onClick={() => setValue(value - 1)}
        icon={<MinusOutlined aria-hidden />}
      />
      <InputNumber
        className="InventoryCardStepper__Input"
        value={value}
        min={min}
        step={1}
        precision={0}
        controls={false}
        inputMode="numeric"
        formatter={formatQuantity}
        parser={parseQuantity}
        onChange={setValue}
        onKeyDown={blockNonNumericInput}
        onPaste={(e) => {
          if (!/^\d+$/.test(e.clipboardData.getData("text").trim())) e.preventDefault();
        }}
      />
      <Button
        type="default"
        className="InventoryCardStepper__Button"
        onClick={() => setValue(value + 1)}
        icon={<PlusOutlined aria-hidden />}
      />
    </div>
  );
};

export default InventoryCardStepper;
